export enum FlexExtendSessionValue {
    FifteenMinutes = 900,
    TwentyMinutes = 1200,
    ThirtyMinutes = 1800,
}

export const FLEX_DIAGNOSTIC_WINDOW_NO_SESSION = 0;

export type FlexDiagnosticWindowExtendSession = typeof FLEX_DIAGNOSTIC_WINDOW_NO_SESSION | FlexExtendSessionValue;

export interface FlexDiagnosticWindowRequest {
    extendSession: FlexExtendSessionValue;
    endTime: string;
}

export interface FlexDiagnosticWindow {
    startTime: string;
    interval: number;
    extendSession: FlexDiagnosticWindowExtendSession;
    endTime: string;
}
